// extracted by mini-css-extract-plugin
export default {"emptyCard":"MisaBrandEmptyState_emptyCard__LMtBD","emptyMessage":"MisaBrandEmptyState_emptyMessage__RW9-m"};